// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"OnboardingHeader_headerContainer__GhCy6","header":"OnboardingHeader_header__JOkZs","subTitle":"OnboardingHeader_subTitle__3YRtx"};